var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.52 23.04C5.16792 23.04 0 17.8721 0 11.52C0 5.16792 5.16792 0 11.52 0C17.8721 0 23.04 5.16792 23.04 11.52C23.04 17.8721 17.8721 23.04 11.52 23.04ZM11.52 1.44C5.96184 1.44 1.44 5.96184 1.44 11.52C1.44 17.0782 5.96184 21.6 11.52 21.6C17.0782 21.6 21.6 17.0782 21.6 11.52C21.6 5.96184 17.0782 1.44 11.52 1.44ZM17.9242 14.0021C18.101 13.6481 17.958 13.2202 17.6057 13.0406C17.2526 12.8623 16.8206 13.0027 16.6385 13.3536C16.5857 13.4549 15.3067 15.84 11.52 15.84C7.7424 15.84 6.46056 13.4666 6.402 13.3546C6.22368 13.0008 5.79192 12.8575 5.43792 13.0361C5.08224 13.2139 4.938 13.6464 5.11584 14.0021C5.18304 14.136 6.80904 17.28 11.52 17.28C16.231 17.28 17.857 14.136 17.9242 14.0021ZM15.12 10.08C14.3258 10.08 13.68 9.43416 13.68 8.64C13.68 7.84584 14.3258 7.2 15.12 7.2C15.9142 7.2 16.56 7.84584 16.56 8.64C16.56 9.43416 15.9142 10.08 15.12 10.08ZM7.92 10.08C7.12584 10.08 6.48 9.43416 6.48 8.64C6.48 7.84584 7.12584 7.2 7.92 7.2C8.71416 7.2 9.36 7.84584 9.36 8.64C9.36 9.43416 8.71416 10.08 7.92 10.08Z",
    fill: "#0A8F43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/Happy.59c3774644636945f51031d968358776.svg";
export { ForwardRef as ReactComponent };